/* eslint-disable no-console */
import {InfoCircleOutlined} from '@ant-design/icons';
import {Divider, Flex} from 'antd';
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import PeerBenchmarkingBg from '../../../../assets/skeleton/PeerBenchmarkingBg.png';
import BlockAccessPage from '../../../../components/BlockAccess/BlockAccessPage';
import Loader from '../../../../components/Loader/Loader';
import PageContent from '../../../../components/PageContent/PageContent';
import Year from '../../../../shared/Year';
import {accessModule} from '../../../../store/companyStore/companyDetailsStore';
import {checkCurrentYearOrBelow} from '../../../../utils/commonFunctions';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {shouldBlockModuleAccess} from '../../../../utils/SubscriptionHelper';

import PeerBenchMarkingContent from './PeerBenchMarkingContent';

const PEER_CONTENT_LOAD_MS = 500;

const PeerBenchmarking: React.FC = () => {
  // const firstYear = yearSelect();

  const [searchParam, setSearchParams] = useSearchParams();
  const [selectedYear, setSelectedYear] = useState('');
  const [isPeerContentReady, setIsPeerContentReady] = useState(false);

  const peerAccessBlocked = shouldBlockModuleAccess(
    accessModule.Reporting_And_ESG,
    accessModule.peer_benchmarking
  );

  const peerContentYearKey =
    (selectedYear || searchParam.get('selectedYear')) ?? '';

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    setSelectedYear(currentYear);
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
  }, []);

  useEffect(() => {
    if (peerAccessBlocked) {
      setIsPeerContentReady(false);

      return;
    }
    if (!peerContentYearKey) {
      setIsPeerContentReady(false);

      return;
    }
    setIsPeerContentReady(false);
    const timer = window.setTimeout(() => {
      setIsPeerContentReady(true);
    }, PEER_CONTENT_LOAD_MS);

    return () => {
      window.clearTimeout(timer);
    };
  }, [peerAccessBlocked, peerContentYearKey]);

  return (
    <PageContent>
      {searchParam.get('selectedYear') && (
        <Flex vertical={false} align="center" justify="space-between">
          <Flex align="center" justify="space-around" gap={5}>
            <div
              style={{
                font: 'normal normal 700 16px Montserrat',
                letterSpacing: '0.56px',
                color: '#282A3A'
              }}
            >
              Peer Benchmarking
            </div>
            <Flex
              style={{
                padding: '6px 12px',
                backgroundColor: '#F3F4F8',
                borderRadius: '100px',
                font: 'normal normal 500 14px Montserrat',
                height: '32px'
              }}
              gap={5}
            >
              <InfoCircleOutlined />
              Based on BRSR Framework
            </Flex>
          </Flex>
          {peerAccessBlocked ? null : (
            <Year
              setSelectedYear={setSelectedYear}
              isESG
              colSpan={24}
              noBottomMargin
            />
          )}
        </Flex>
      )}
      <Divider
        orientationMargin="0"
        className="divider"
        style={{margin: '12px'}}
      />
      {peerAccessBlocked ? (
        <div style={{height: 900}}>
          <BlockAccessPage backgroundImage={PeerBenchmarkingBg} />
        </div>
      ) : isPeerContentReady ? (
        <PeerBenchMarkingContent selectedYear={peerContentYearKey} />
      ) : (
        <div style={{minHeight: 480}}>
          <Loader isHome={true} />
        </div>
      )}
    </PageContent>
  );
};

export default PeerBenchmarking;
